/**
 * Copyright (c) 2017.  INTERIA.PL (www.interia.pl)
 **/

/**
 * Created by vladyslav on 27.11.17.
 */
import Ad from './Ad';
import AdsSidebar from './AdsSidebar';
import AdSidebarService from './AdSidebarService';
import { windowLoaded, outerHeightWithMargin } from './helper';

(function (w, d) {
    console.warn('------------------ Ads_sidebar ------------------');

    const mainContentSelector = '.main-content',
        adsSidebarSelector = '#content .main-sidebar';

    // let isResized
    w.Inpl = w.Inpl || {};
    w.Inpl.adsSidebar = { services: [] };

    const isDefined = el => {
            return typeof el !== 'undefined';
        },
        isObject = el => {
            return isDefined(el) && typeof el === 'object';
        },
        /**
         * main action func
         */
        main = (contentSel, adsSidebarSel) => {
            try {
                let content = null,
                    adsSidebar = null;

                if (!isDefined(contentSel)) {
                    return false;
                }

                if (!isDefined(adsSidebarSel)) {
                    return false;
                }

                if (isObject(contentSel)) {
                    content = contentSel;

                } else {
                    content = d.querySelector(contentSel);
                }

                if (isObject(adsSidebarSel)) {
                    adsSidebar = adsSidebarSel;

                } else {
                    adsSidebar = d.querySelector(adsSidebarSel);
                }

                w.Inpl.testSlots = adsSidebar;

                let ads = [],
                    adHeights = 0;

                if (content && adsSidebar) {

                    const adsSidebarDivStyle = getComputedStyle(adsSidebar),
                        sidebarAds = adsSidebar.children;

                    adsSidebar.style.height = content.clientHeight + 'px';

                    if (adsSidebarDivStyle.display === 'block') {

                        Object.keys(sidebarAds).forEach(key => {
                            const element = sidebarAds[key];

                            if (typeof element === 'object' && element.clientHeight > 0) {

                                console.warn('element id: ', element.id);
                                console.warn('clientHeight: ', element.clientHeight);
                                console.warn('height calc: ', outerHeightWithMargin(element));

                                const height = outerHeightWithMargin(element);
                                adHeights += height;

                                ads.push(new Ad({
                                    element,
                                    place: element.id,
                                    adsSidebar,
                                    w,
                                    height
                                }));
                            }
                        });

                        const sidebar = new AdsSidebar({
                            ads,
                            element: adsSidebar,
                            contentHeight: content.clientHeight,
                            adHeights
                        });

                        sidebar.calcOffsetTop();

                        const service = new AdSidebarService(sidebar);
                        service.contentSelector = contentSel;
                        service.adsSidebarSelector = adsSidebarSel;

                        if (content.clientHeight > adHeights) {
                            service.calcVisibilityRanges();
                            service.updateAdsPositions();

                            const serviceExists = w.Inpl.adsSidebar.services.find(s => s.contentSelector === contentSel);

                            if (!serviceExists) {
                                w.Inpl.adsSidebar.services.push(service);
                            }
                        }

                        // w.addEventListener('scroll', () => {
                        //     if (content.clientHeight > adHeights) {
                        //         const { services } = w.Inpl.adsSidebar;
                        //
                        //         services.forEach(s => doOnResize(s));
                        //     }
                        // });
                    }
                }
            } catch (e) {
                console.error(e);
            }
        };

    /**
     * do height calculation for each slot, content and article
     */
    const doOnResize = service => {

        const { sidebar } = service,
            content = d.querySelector(service.contentSelector),
            adsSidebarDiv = d.querySelector(service.adsSidebarSelector),
            { children } = adsSidebarDiv,
            adsSidebarDivStyle = getComputedStyle(adsSidebarDiv);

        adsSidebarDiv.style.height = content.clientHeight + 'px';

        if (adsSidebarDivStyle.display === 'block') {

            let sidebarAds = new Map(),
                adHeights = 0;

            Object.keys(children).forEach(key => {
                sidebarAds.set(children[key].id, children[key]);
            });

            sidebar._ads.forEach(ad => {
                const slot = sidebarAds.get(ad.element.id),
                    height = outerHeightWithMargin(slot);

                ad.height = height;
                adHeights += height;

                return ad;
            });

            sidebar.calcOffsetTop();
            sidebar.adHeights = adHeights;
            sidebar.contentHeight = content.clientHeight;

            service.sidebar = sidebar;
            service.calcVisibilityRanges();
            service.updateAdsPositions();
        }
    };

    w.Inpl.adsSidebar.runSidebar = main;

    // for new ads service Inpl.uanc
    w.addEventListener('Inpl.adsLoaded', function adsLoadedHandler(e) {
        const { target, type } = e;

        target.removeEventListener(type, adsLoadedHandler);

        if (w.innerWidth > 999) {

            main(mainContentSelector, adsSidebarSelector);

            w.addEventListener('resize', () => {
                const { services } = w.Inpl.adsSidebar;

                setTimeout(() => {
                    services.forEach(service => doOnResize(service));
                }, 100);
            });

            w.addEventListener('portalTopped', function portalToppedHandler(portalToppedEvent) {

                portalToppedEvent.target.removeEventListener(portalToppedEvent.type, portalToppedHandler);

                const { services } = w.Inpl.adsSidebar;

                setTimeout(() => {
                    services.forEach(service => doOnResize(service));
                }, 100);
            });

            w.addEventListener('renderForum', function renderForumHandler(renderForumEvent) {
                renderForumEvent.target.removeEventListener(renderForumEvent.type, renderForumHandler);

                const { services } = w.Inpl.adsSidebar;

                setTimeout(() => {
                    services.forEach(service => doOnResize(service));
                }, 100);
            });
        }
    });

    /**
     * main app entry
     * collect all promises
     */
    windowLoaded()
        .then(() => {

                const self = w.Inpl.Ad;

                if (!self.hasOwnProperty('isNewService') && w.innerWidth > 999) {

                    setTimeout(() => main(mainContentSelector, adsSidebarSelector), 2000);

                    w.addEventListener('scroll', () => {
                        const { services } = w.Inpl.adsSidebar;

                        services.forEach(s => doOnResize(s));
                    });

                    w.addEventListener('resize', () => {
                        const { services } = w.Inpl.adsSidebar;

                        setTimeout(() => services.forEach(service => doOnResize(service)), 300);
                    });

                    w.addEventListener('portalTopped', function portalToppedHandler(e) {
                        e.target.removeEventListener(e.type, portalToppedHandler);

                        const { services } = w.Inpl.adsSidebar;

                        setTimeout(() => {
                            services.forEach(service => doOnResize(service));
                        }, 100);
                    });

                    w.addEventListener('renderForum', function renderForumHandler(e) {
                        e.target.removeEventListener(e.type, renderForumHandler);

                        const { services } = w.Inpl.adsSidebar;

                        setTimeout(() => {
                            services.forEach(service => doOnResize(service));
                        }, 100);
                    });
                }
            }
        );
})(window, document);



// WEBPACK FOOTER //
// ./source/app.js